import React from 'react'
import { useTranslation } from 'react-i18next'
import { ChartItems } from '../../../../types/DashboardType'
import KnobChart from '../../chart-components/knob/Knob'
import TotalNotification from '../../chart-components/TotalNotification/TotalNotification'

const KnobChartContainer = (props: {
  detailTitle: string
  response: ChartItems | undefined
  icon: any
  total: number
  colors: string[]
}) => {
  const { t } = useTranslation()
  const labels = [
    t('dashboard.at-least-one-firm'),
    t('dashboard.at-least-one-shared'),
    t('dashboard.at-least-one-remote'),
  ]
  return (
    <div>
      <div className="ms-4">
        <TotalNotification
          detailTitle={props.detailTitle}
          totalNotificationCount={props.response?.doughnutItems.total}
          icon={props.icon}
        />
      </div>

      {props.response?.doughnutItems.datasets.map((value, index) => (
        <KnobChart value={value} key={index} color={props.colors[index]} label={labels[index]} total={props.total} />
      ))}
    </div>
  )
}

export default KnobChartContainer
